<img src="{{ loadingIndicatorPath | asset }}" alt="please wait..." class="small-loading-indicator" />
